import API from "../../../api/axiosClient";
import { ContactCreateDto, ContactResponseDto } from "../types/authTypes";

 

/**
 * Submit Contact Form
 */
export const submitContact = async (
  data: ContactCreateDto
) => {
  const response = await API.post(
    "/Auth/contact",
    data
  );

  return response.data;
};

/**
 * Get Contact List (Admin)
 */
export const getContactList = async () => {
  const response = await API.get<ContactResponseDto[]>(
    "/Users/get-contact-list"
  );

  return response.data;
};